import { FormError } from 'app/hooks';
import { t } from 'i18next';

export const buildErrorMessage = (res: any): string => {
  // eslint-disable-next-line eqeqeq
  if (res) {
    if (res.status === 401 || res.status === 403) {
      return res.code;
    } else {
      return res.response?.data?.error?.message ?? t('info.genericError');
    }
  } else {
    return t('info.genericError');
  }
};

export const buildErrorDetails = (res: any): FormError<any>[] => {
  if (res.status >= 400) {
    if (res?.response?.data?.detail) {
      const formErrors: FormError<any>[] = [];
      res?.response?.data?.detail?.forEach((val: { loc: string[]; msg: string }) => {
        formErrors.push({ field: val.loc[val.loc.length - 1], error: val.msg, path: undefined });
      });
      return formErrors;
    }
  }
  return [];
};
